// Customizable Area Start
import React, { useState, useEffect } from 'react';
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  FlatList,
} from 'react-native';
import ChevronRight from "@material-ui/icons/ChevronRight";
import Dialog from '@material-ui/core/Dialog';
import { getRole, logOut, ROLE_ID } from '../../../framework/src/Utilities';
import * as IMG_CONST from '../../../blocks/dashboard/src/assets'

export default function Menue({ navigation, state, userData }: { navigation: any, state: any, userData: any }) {

  const routeListSurgeon = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: 'confirmed',
      image: IMG_CONST.homeIcon,
      imagDesktope: IMG_CONST.homeDesktop,
    },
    {
      name: "Profile",
      routename: "Profile",
      status: 'confirmed',
      image: IMG_CONST.personsmall,
      imagDesktope: IMG_CONST.userDesktop,
    },
    {
      name: "Existing Booking",
      routename: "ExBooking",
      status: 'confirmed',
      image: IMG_CONST.book,
      Desktop: IMG_CONST.book
    },
    {
      name: "Start New Booking",
      routename: "CreateBooking",
      status: 'confirmed',
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: 'confirmed',
      image: IMG_CONST.shopping,
      Desktop: IMG_CONST.shopping
    },
    {
      name: "My Facility",
      routename: "UserFacilities",
      status: 'confirmed',
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "History",
      routename: "History",
      status: 'confirmed',
      image: IMG_CONST.calendar,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Tracking",
      routename: "Tracking",
      status: 'confirmed',
      image: IMG_CONST.tracking,
      Desktop: IMG_CONST.navigationDesktop
    },
    {
      name: "Invite Users",
      routename: "AddTeam",
      status: 'confirmed',
      image: IMG_CONST.invite,
      Desktop: IMG_CONST.personDesktop
    },
    {
      name: "Notification",
      routename: "Notification",
      status: 'confirmed',
      image: IMG_CONST.bell,
      Desktop: IMG_CONST.bellDesktop
    },
    {
      name: "Logout",
      routename: "Logout",
      status: 'confirmed',
      image: IMG_CONST.logout,
      Desktop: IMG_CONST.logout
    }
  ];

  const routeListMaterialManage = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: 'confirmed',
      image: IMG_CONST.homeIcon,
      Desktop: IMG_CONST.homeDesktop
    },
    {
      name: "Profile",
      routename: "Profile",
      status: 'confirmed',
      image: IMG_CONST.personsmall,
      Desktop: IMG_CONST.userDesktop
    },
    {
      name: "Validate New Manager",
      routename: "ValidateManager",
      status: 'confirmed',
      image: IMG_CONST.validateNewManager,
      Desktop: IMG_CONST.cameraDesktop
    },
    {
      name: "Generate Reports ",
      routename: "UserActivityReport",
      status: "confirmed",
      image: IMG_CONST.calendar,
      Desktop: IMG_CONST.calendarDesktop,
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: 'confirmed',
      image: IMG_CONST.shopping,
      Desktop: IMG_CONST.shopping
    },
    {
      name: "Validate New Surgeon",
      routename: "ValidateNewSurgeonBlock",
      status: 'confirmed',
      image: IMG_CONST.userIcon,
      Desktop: IMG_CONST.cameraDesktop
    },
    {
      name: "New Material",
      routename: window.screen.width < 950 ? "ChooseAddMaterialType" : "NewMaterial",
      status: 'confirmed',
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "History",
      routename: "History",
      status: 'confirmed',
      image: IMG_CONST.calendar,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Notification",
      routename: "Notification",
      status: 'confirmed',
      image: IMG_CONST.bell,
      Desktop: IMG_CONST.bellDesktop
    },
    {
      name: "Logout",
      routename: "Logout",
      image: IMG_CONST.logout,
      status: 'confirmed',
      Desktop: IMG_CONST.logout
    }
  ];


  const routeListBookingCoordinator = [
    {
      name: "Dashboard",
      status: 'confirmed',
      routename: "Dashboard",
      image: IMG_CONST.homeIcon,
      Desktop: IMG_CONST.homeDesktop
    },
    {
      name: "Profile",
      status: 'confirmed',
      routename: "Profile",
      image: IMG_CONST.personsmall,
      Desktop: IMG_CONST.userDesktop
    },
    {
      name: "All Booking",
      status: 'confirmed',
      routename: "ExBooking",
      image: IMG_CONST.validateNewManager,
      Desktop: IMG_CONST.cameraDesktop
    },
    {
      name: "Generate Reports ",
      routename: "UserActivityReport",
      status: "confirmed",
      image: IMG_CONST.calendar,
      Desktop: IMG_CONST.calendarDesktop,
    },
    {
      name: "Validate BC",
      status: 'confirmed',
      routename: "ValidateBC",
      image: IMG_CONST.userIcon,
      Desktop: IMG_CONST.cameraDesktop
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: 'confirmed',
      image: IMG_CONST.shopping,
      Desktop: IMG_CONST.shopping
    },
    {
      name: "My Facility",
      status: 'confirmed',
      routename: "UserFacilities",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "History",
      routename: "History",
      status: 'confirmed',
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "Notification",
      routename: "Notification",
      status: 'confirmed',
      image: IMG_CONST.bell,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Logout",
      routename: "Logout",
      status: 'confirmed',
      image: IMG_CONST.logout,
      Desktop: IMG_CONST.logout
    }
  ];


  const routeListSalesRep = [
    {
      name: "Dashboard",
      status: 'confirmed',
      routename: "Dashboard",
      image: IMG_CONST.homeImg,
      Desktop: IMG_CONST.homeDesktop
    },
    {
      name: "Profile",
      status: 'confirmed',
      routename: "Profile",
      image: IMG_CONST.personsmall,
      Desktop: IMG_CONST.userDesktop
    },
    {
      name: "All Booking",
      status: 'confirmed',
      routename: "ExBooking",
      image: IMG_CONST.book,
      Desktop: IMG_CONST.book
    },
    {
      name: "History",
      status: 'confirmed',
      routename: "History",
      image: IMG_CONST.plus,
      Desktop: IMG_CONST.plusDesktop
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: 'confirmed',
      image: IMG_CONST.shopping,
      Desktop: IMG_CONST.shopping
    },
    {
      name: "Manage Manufacturers",
      status: 'confirmed',
      routename: "UserManufacturers",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "Add New Material",
      status: 'confirmed',
      routename: "NewMaterial",
      image: IMG_CONST.hospital,
      Desktop: IMG_CONST.hospitalDesktop
    },
    {
      name: "Confirm Material Details",
      status: 'confirmed',
      routename: "RequestedMaterial",
      image: IMG_CONST.calendar,
      Desktop: IMG_CONST.calendarDesktop
    },
    {
      name: "Notification",
      status: 'confirmed',
      routename: "Notification",
      image: IMG_CONST.bell,
      Desktop: IMG_CONST.navigationDesktop
    },
    {
      name: "Out Of Office",
      status: 'confirmed',
      routename: "OutOfOffice",
      image: IMG_CONST.bell,
      Desktop: IMG_CONST.bellDesktop
    },
    {
      name: "Logout",
      status: 'confirmed',
      routename: "Logout",
      image: IMG_CONST.logout,
      Desktop: IMG_CONST.logout
    }
  ];


  useEffect(() => {
    const assignlist = () => {
      const user = JSON.parse(
        localStorage.getItem("loggedinUserInfo") || "{}"
      );
      let id = Number(user.role_id).toString()
      if (id === ROLE_ID.SURGEON) {
        setrouteList(routeListSurgeon)
      } else if (id === ROLE_ID.MATERIAL_MANAGER) {
        setrouteList(routeListMaterialManage);
      } else if (id === ROLE_ID.BOOKING_COORDINATOR) {
        setrouteList(routeListBookingCoordinator);
      } else {
        setrouteList(routeListSalesRep)
      }
    }

    assignlist()

  }, [])

  const changeRoute = (route: any) => {
    state({ left: false })
    navigation.navigate(route)
  }




  const [routeList, setrouteList] = useState<any>([]);




  let roleId = localStorage.getItem('role')

  const [open, setOpen] = useState(false)

  const handleClose = () => {

  }



  return (
    <View style={styles.container}>
      <View style={styles.profile}>
        <View style={{ flexDirection: 'row', }}>
          <TouchableOpacity onPress={() => navigation.navigate('Profile')}>
            <img src={userData.profile_image ? userData.profile_image : IMG_CONST.avatarChat1} style={{ height: 110, width: 110, borderRadius: '50%' }} />
          </TouchableOpacity>
          {/* <TouchableOpacity onPress={() => navigation.navigate('Profile')}>
           <img src={"../assets/edit.png")} style={{ height: 24, width: 24, marginTop: 70, borderRadius: '50%', marginLeft: 20, position: 'absolute' }} />
          </TouchableOpacity> */}
        </View>

        <Text style={styles.profileText}>{userData?.first_name + " " + userData?.last_name}</Text>
        <Text style={styles.profileText2}>Role: {getRole(JSON.stringify(userData.role_id))}</Text>
      </View>
      <View style={styles.subWrapper}>
        <FlatList
          data={routeList}
          keyExtractor={(item: any) => item.name}
          renderItem={({ item }) => {
            return (
              <>
                {item.status === 'pending' ?
                  <View
                    style={styles.menuWrapper}
                  >
                    <View style={{ flexDirection: "row" }}>
                      <Image source={item.image} style={styles.menuImage} />

                      <Text style={styles.menuName2}>{item.name}</Text>
                    </View>

                    <ChevronRight color={"disabled"} />
                  </View> :
                  <TouchableOpacity
                    style={styles.menuWrapper}
                    onPress={() => item.name === 'Logout' ? logOut() : changeRoute(item.routename)}
                  >
                    <View style={{ flexDirection: "row" }}>
                      <Image source={item.image} style={styles.menuImage} />

                      <Text style={styles.menuName}>{item.name}</Text>
                    </View>

                    <ChevronRight color={"disabled"} />
                  </TouchableOpacity>
                }  </>
            );

          }}
        />
      </View>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <Text>You are not Validate by your respective manager yet</Text>
      </Dialog>
    </View>
  )
}



const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#4E3E71"
  },
  profileImage: {
    width: 100,
    height: 100,
    backgroundColor: "#b2bac6",
    borderRadius: 99
  },
  profileText: {
    color: "#fff",
    fontSize: 24
  },
  profileText2: {
    color: "#fff",
    fontSize: 14,
    paddingTop: 5
  },
  profile: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#4E3E71",
    paddingHorizontal: 50,
    flex: 0.3
  },
  menuImage: { height: 24, width: 24, marginRight: 8, resizeMode: 'contain' },
  menuName: { fontSize: 14, color: "#4e3e71", marginTop: 4, marginLeft: 10 },
  menuName2: { fontSize: 14, color: "#b2bac6", marginTop: 4, marginLeft: 10 },
  menuWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: 24,
    width: "100%",
    paddingHorizontal: 10,
    alignItems: "center"
  },
  subWrapper: {
    borderTopEndRadius: 24,
    zIndex: 999,
    backgroundColor: "#E8FAFE",
    flex: 0.7
  }

})
// Customizable Area End